import React from 'react'
import { Input, Btn } from '../ui/index.jsx'
import { useLanguage } from '../../i18n/index.jsx'

interface PasswordForm {
  current_password: string
  new_password: string
  confirm_password: string
}

interface PasswordChangerProps {
  form: PasswordForm
  setForm: (form: PasswordForm) => void
  error: string | null
  success: boolean
  loading: boolean
  onSubmit: React.FormEventHandler<HTMLFormElement>
  onClose: () => void
}

export default function PasswordChanger({ form, setForm, error, success, loading, onSubmit, onClose }: PasswordChangerProps) {
  const { t } = useLanguage()

  return (
    <div>
      <h3 style={{ fontSize: 'var(--text-base)', fontWeight: 600, marginBottom: '1rem' }}>{t('changePasswordSection')}</h3>
      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {error && (
          <div style={{
            background: 'var(--danger-dim)', border: '1px solid rgba(248,113,113,0.2)',
            color: 'var(--danger)', padding: '10px 12px', borderRadius: 'var(--radius)',
            fontSize: 'var(--text-caption)'
          }}>
            {error}
          </div>
        )}
        {success && (
          <div style={{
            background: 'var(--success-dim)', border: '1px solid rgba(52,211,153,0.2)',
            color: 'var(--success)', padding: '10px 12px', borderRadius: 'var(--radius)',
            fontSize: 'var(--text-caption)'
          }}>
            {t('passwordChangedSuccessfully')}
          </div>
        )}
        <Input
          label={t('currentPassword')}
          type="password"
          value={form.current_password}
          onChange={e => setForm({ ...form, current_password: e.target.value })}
          disabled={loading}
          required
        />
        <Input
          label={t('newPassword')}
          type="password"
          value={form.new_password}
          onChange={e => setForm({ ...form, new_password: e.target.value })}
          disabled={loading}
          hint={t('minimum8Chars')}
          required
        />
        <Input
          label={t('confirmPassword')}
          type="password"
          value={form.confirm_password}
          onChange={e => setForm({ ...form, confirm_password: e.target.value })}
          disabled={loading}
          required
        />
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '0.5rem' }}>
          <Btn variant="ghost" type="button" onClick={onClose} disabled={loading}>
            {t('cancel')}
          </Btn>
          <Btn variant="primary" type="submit" loading={loading}>
            {t('save')}
          </Btn>
        </div>
      </form>
    </div>
  )
}
